// Auto-generated by set-version.js
export const buildInfo = {
  version: '1.0.0',
  hash: 'TEMP-Z0IHAF',
  builtAt: '2026-11-04T14:18:09.398Z'
};
